module.exports = __webpack_public_path__ + "img/goods_04.1934a452.jpg";